import { createSvg, SVGIcon } from '@amzn/atoz-web/Icons';
export var MediumCheckIcon = createSvg('MediumCheckIcon', // name
new SVGIcon([
    // paths
    'M55.1866,24.1178 L33.3116,50.3678 C32.6816,51.1238 31.7646,51.5788 30.7811,51.6208 C30.7286,51.6243 30.6761,51.6243 30.6236,51.6243 C29.6961,51.6243 28.8071,51.2603 28.1491,50.5988 L15.0241,37.4738 C13.6591,36.1088 13.6591,33.8933 15.0241,32.5248 C16.3926,31.1598 18.6081,31.1598 19.9731,32.5248 L30.3891,42.9408 L49.8106,19.6343 C51.0461,18.1503 53.2511,17.9508 54.7386,19.1863 C56.2226,20.4218 56.4256,22.6303 55.1866,24.1178 M34.9986,-0.0007 C15.6681,-0.0007 -0.0014,15.6723 -0.0014,34.9993 C-0.0014,54.3298 15.6681,69.9993 34.9986,69.9993 C54.3291,69.9993 69.9986,54.3298 69.9986,34.9993 C69.9986,15.6723 54.3291,-0.0007 34.9986,-0.0007'
], { width: '70', height: '70' }, // params
70, // width
70 // height
));
